import React from 'react';
import * as S from './AdSlotUI.styles';

const AdSlotUI = ({homePageBannerClickHandler}) => (
  <S.AdvertisementUIMainWrapper>
    <div>
      <mmtad id="1" lob="HOTEL" pageName="LandigPage" section="middle"></mmtad>
    </div>
  </S.AdvertisementUIMainWrapper>
);

export default AdSlotUI;
